import React from 'react';
import './chat-extra-info.scss';

export interface ChatExtraInfoData {
  propertyName: string;
  itemName: string;
  issueType: string;
}

interface ChatExtraInfoProps {
  extraInfo: ChatExtraInfoData;
}

const ChatExtraInfo = ({ extraInfo }: ChatExtraInfoProps) => {
  return (
    <div className="chat-extra-info">
      {extraInfo.propertyName && (
        <div className="extra-info-item">
          <div className="extra-info-label">Property</div>
          <div className="extra-info-value">{extraInfo.propertyName}</div>
        </div>
      )}
      {extraInfo.itemName && (
        <div className="extra-info-item">
          <div className="extra-info-label">Item</div>
          <div className="extra-info-value">{extraInfo.itemName}</div>
        </div>
      )}
      {extraInfo.issueType && (
        <div className="extra-info-item">
          <div className="extra-info-label">Issue Type</div>
          <div className="extra-info-value">{extraInfo.issueType}</div>
        </div>
      )}
    </div>
  );
};

export default ChatExtraInfo;